<template>
  <div class="avatar">
    <div class="avatar__level">
      <img src="@/assets/practices/global/avatar/avatar_level.svg" alt="avatar_level" class="avatar__level--bg" />
      <div class="avatar__level--number">{{ level }}</div>
    </div>
    <div class="avatar__image">
      <img class="avatar__image--bg" src="@/assets/practices/global/avatar/avatar_image_bg.svg" alt="avatar_image_bg" />
      <img :src="image" alt="avatar_image" class="avatar__image--main" />
    </div>
    <div id="avatar__progress">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 823.68 823.44">
        <defs>
          <linearGradient
            id="f6113a27-4edf-4373-9bf0-2ee011e617ff"
            y1="411.72"
            x2="823.68"
            y2="411.72"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.59" stop-color="#2bfff1" />
            <stop offset="0.61" stop-color="#44fdd8" />
            <stop offset="0.66" stop-color="#74f9a8" />
            <stop offset="0.72" stop-color="#9ef67f" />
            <stop offset="0.77" stop-color="#c0f35d" />
            <stop offset="0.82" stop-color="#daf142" />
            <stop offset="0.88" stop-color="#edef30" />
            <stop offset="0.94" stop-color="#f8ee25" />
            <stop offset="1" stop-color="#fcee21" />
          </linearGradient>
        </defs>
        <title>Progress</title>
        <g id="fc53856f-adb6-4b7a-8fd6-81c3c4491951" data-name="Layer 2">
          <g id="ab754130-341f-421d-8e9e-52978dc8eb0c" data-name="Layer 10">
            <path
              id="progressPath"
              d="M398.16,805.33C188.3,798,18.11,623.2,18.11,411.84c0-216,177.74-393.73,393.73-393.73S805.57,195.85,805.57,411.84c0,205.51-160.9,376.74-363.2,392.54"
            />
          </g>
        </g>
      </svg>
    </div>
    <div class="avatar__name">
      <img src="@/assets/practices/global/avatar/avatar_name.svg" alt="avatar_name" class="avatar__name--bg" />
      <div class="avatar__name--text">{{ name }}</div>
    </div>
  </div>
</template>

<script>
import ProgressBar from 'progressbar.js';
// import { mapGetters } from 'vuex';

export default {
  name: 'Avatar',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    image: String,
    // eslint-disable-next-line vue/require-default-prop
    game: String,
    // eslint-disable-next-line vue/require-default-prop
    level: Number,
    // eslint-disable-next-line vue/require-default-prop
    name: String,
    // eslint-disable-next-line vue/require-default-prop
    progress: Number,
  },
  computed: {
    gameCompleted() {
      return this.$store.state[this.game].gameCompleted;
    },
  },
  watch: {
    gameCompleted() {
      const bar = new ProgressBar.Path('#progressPath', {
        easing: 'easeInOut',
        duration: 2500,
      });

      bar.set(0);
      bar.animate(this.progress); // Number from 0.0 to 1.0
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'TheBoldFont';
  src: url('~@/assets/fonts/TheBoldFont.eot?#iefix') format('embedded-opentype'),
    url('~@/assets/fonts/TheBoldFont.woff') format('woff'), url('~@/assets/fonts/TheBoldFont.ttf') format('truetype'),
    url('~@/assets/fonts/TheBoldFont.svg#TheBoldFont') format('svg');
  font-weight: normal;
  font-style: normal;
}

* {
  font-family: 'TheBoldFont';
  color: #8900a5;
}

@mixin settings-flex {
  align-items: center;
  display: flex;
  justify-content: center;
}

.avatar {
  @include settings-flex;
  height: 15vw;
  margin-top: 1.25%;
  position: absolute;
  text-align: center;
  right: 0;
  top: 0;
  width: 15vw;
  z-index: 100;

  .avatar__level {
    @include settings-flex;
    position: absolute;
    z-index: 3;
    top: -10%;
    height: 25%;

    .avatar__level--bg {
      position: absolute;
      height: 100%;
    }

    .avatar__level--number {
      @include settings-flex;
      position: absolute;
      z-index: 2;
      font-size: 0.85em;
      transform: translateY(6.5%);
    }
  }

  .avatar__image {
    @include settings-flex;
    height: 100%;
    width: 100%;

    .avatar__image--bg {
      position: absolute;
      height: 100%;
      width: 100%;
    }

    .avatar__image--main {
      position: absolute;
      height: 75%;
      width: 75%;
      border-radius: 50%;
      transform: translate(-0.75%, -1%);
      object-fit: cover;
    }
  }

  .avatar__name {
    @include settings-flex;
    position: absolute;
    width: 100%;
    z-index: 3;
    bottom: 6%;

    .avatar__name--bg {
      position: absolute;
      width: 100%;
    }

    .avatar__name--text {
      @include settings-flex;
      position: absolute;
      z-index: 2;
      // height: 80%;
      font-size: 0.6em;
      transform: translateY(4.5%);
    }
  }

  #avatar__progress {
    position: absolute;
    height: 90%;
    width: 90%;
    transform: translate(-0.25%, -1.25%);
    z-index: 2;
  }

  #progressPath {
    fill: none;
    stroke-linecap: round;
    stroke-miterlimit: 10;
    stroke-width: 36.22px;
    stroke: url(#f6113a27-4edf-4373-9bf0-2ee011e617ff);
  }
}
</style>
